module.exports = __webpack_public_path__ + "img/03_DSC7672-min.ab46f405.jpg";